<template>
    <v-navigation-drawer id="nav-wrap" theme="background" v-model="drawer" :width="310"
        @update:modelValue="(val) => $emit('setDrawerState', val)">
        <div class="d-flex flex-column" style="height: 100%; position: relative;">
            <div class="flex-shrink-0">
                <img class="subtract" :src="require('@/assets/images/Subtract.png')" @click.stop="appBarDisplay" />

                <v-container>
                    <v-row no-gutter>
                        <v-col class="nav-log-container d-flex flex-column align-center mx-1 my-2">
                            <a class="nav-brand-title" @click.stop="mainRouter">Draco</a>
                            <div class="nav-brand-subtitle-wrapper">
                                <span class="nav-brand-subtitle">Agentic RAG <span
                                        class="nav-brand-version">v1.0</span></span>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row no-gutter>
                        <v-col class="new-request-btn-container">
                            <img class="new-request-btn" :src="require('@/assets/images/new-request-button.png')"
                                @click="startNewChat" />
                        </v-col>
                    </v-row>
                </v-container>
            </div>

            <div class="flex-grow-1 overflow-y-auto" style="padding-bottom: 70px;">
                <v-list nav>
                    <template v-if="historySessions.length > 0">
                        <v-divider class="my-2"></v-divider>
                        <v-list-subheader class="px-4 text-caption text-uppercase font-weight-bold"
                            style="color:#666">최근 대화</v-list-subheader>

                        <v-list-item v-for="session in historySessions" :key="session.chatSessSeq"
                            @click="loadSession(session.chatSessSeq)"
                            @mouseenter="scheduleSessionMenu(session, $event)" @mouseleave="scheduleSessionMenuClose"
                            @focus="scheduleSessionMenu(session, $event)" @blur="scheduleSessionMenuClose"
                            :class="['history-item', { 'selected-session': $route.query.sess == session.chatSessSeq }]">
                            <v-list-item-title class="history-session-title">
                                <v-icon v-if="session.fixYn === 'Y'" color="primary" size="x-small"
                                    class="mr-1">mdi-pin</v-icon>
                                {{ session.chatSessNm }}
                            </v-list-item-title>
                        </v-list-item>
                    </template>
                </v-list>
            </div>

            <v-menu v-model="showSessionMenu" :activator="sessionMenuActivator" location="end center" offset="15"
                :open-on-click="false" :open-on-focus="false"
                :content-props="{ onMouseenter: cancelSessionMenuTimers, onMouseleave: scheduleSessionMenuClose,
                    onFocusin: cancelSessionMenuTimers, onFocusout: handleSessionMenuFocusOut }">
                <v-card v-if="menuSession" class="preview-card" min-width="220" max-width="350">
                    <v-card-text class="pa-3">
                        <div class="d-flex align-center mb-3">
                            <v-icon size="small" color="primary" class="mr-2">mdi-chat-processing-outline</v-icon>
                            <span class="preview-full-title">{{ menuSession.chatSessNm }}</span>
                        </div>
                        <v-divider class="mb-2"></v-divider>
                        <div class="d-flex justify-end gap-2">
                            <v-btn size="x-small" variant="tonal"
                                :color="menuSession.fixYn === 'Y' ? 'grey' : 'primary'"
                                :prepend-icon="menuSession.fixYn === 'Y' ? 'mdi-pin-off' : 'mdi-pin'"
                                @click.stop="togglePin(menuSession)">
                                {{ menuSession.fixYn === 'Y' ? '고정 해제' : '고정' }}
                            </v-btn>
                            <v-btn size="x-small" variant="tonal" color="error" prepend-icon="mdi-delete"
                                @click.stop="deleteSession(menuSession)">
                                삭제
                            </v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </v-menu>

            <footer class="nav-footer">
                <!-- User Profile with logout menu -->
                <v-menu v-model="showUserMenu" offset="10" location="top start">
                    <template v-slot:activator="{ props }">
                        <div v-bind="props" class="d-flex align-center user-profile-clickable">
                            <img class="person-button" :src="require('@/assets/images/person.png')" />
                            <div style="padding-left: 10px;">{{ userNm }}</div>
                        </div>
                    </template>
                    <v-list density="compact" nav class="user-footer-list">
                        <v-list-item prepend-icon="mdi-logout" title="로그아웃" value="logout" @click="logout"
                            class="logout-menu-item"></v-list-item>
                    </v-list>
                </v-menu>

                <!-- RAG Management dropdown -->
                <v-menu v-if="authrtId === 'A001' || authrtId === 'D001'" v-model="showRagMenu"
                    :close-on-content-click="false" offset="10" location="top end">
                    <template v-slot:activator="{ props }">
                        <v-btn icon v-bind="props" variant="text" size="small" class="mr-2" title="RAG 관리">
                            <v-icon color="#666">mdi-database-cog-outline</v-icon>
                        </v-btn>
                    </template>
                    <v-list density="compact" nav class="rag-footer-list">
                        <v-list-subheader class="text-caption font-weight-bold">RAG 관리</v-list-subheader>
                        <template v-for="menu in menuList" :key="menu.menuId">
                            <!-- Show Level 1 items and their Level 2 children flatly -->
                            <template v-if="menu.upperMenuId === '1'">
                                <!-- Level 1 Item -->
                                <v-list-item v-if="menu.url" :prepend-icon="menu.tag1" :title="menu.menuDesc"
                                    :value="menu.menuNm" :to="menu.url" density="compact" class="rag-footer-item-l1"
                                    @click="menuActionClick(menu.url, menu.upperMenuNm, menu.menuNm, menu.tag1)"></v-list-item>

                                <!-- Level 1 header-only item (like DB Management) -->
                                <template v-else>
                                    <v-list-item :prepend-icon="menu.tag1" :title="menu.menuDesc"
                                        class="rag-footer-item-l1 rag-footer-header" density="compact"
                                        disabled></v-list-item>

                                    <!-- Level 2 items -->
                                    <div class="rag-footer-submenu-group">
                                        <template v-for="subMenu in menuList" :key="subMenu.menuId">
                                            <v-list-item v-if="menu.menuId === subMenu.upperMenuId"
                                                :value="subMenu.menuNm" :to="subMenu.url" density="compact"
                                                class="rag-footer-submenu"
                                                @click="menuActionClick(subMenu.url, subMenu.upperMenuNm, subMenu.menuNm, subMenu.tag1)">
                                                <template v-slot:title>
                                                    {{ subMenu.menuDesc }}
                                                </template>
                                            </v-list-item>
                                        </template>
                                    </div>
                                </template>
                            </template>
                        </template>
                    </v-list>
                </v-menu>

            </footer>
        </div>
    </v-navigation-drawer>


</template>

<script setup>

import { ref, shallowRef, watch, nextTick, defineExpose, onMounted, onUnmounted, getCurrentInstance } from 'vue'
import axios from '@/plugins/axios';
import store from '../../store';
import { useRouter } from 'vue-router'

const { proxy, emit } = getCurrentInstance();

const drawer = ref(true);

const menuList = ref([
    {
        menuId: "1",
        menuNm: "RAG Management",
        menuDesc: "RAG 관리",
        menuLvl: 0,
        url: "",
        tag1: "mdi-database-search"
    },
    {
        menuId: "1-1",
        upperMenuId: "1",
        upperMenuNm: "RAG Management",
        menuNm: "Document Management",
        menuDesc: "문서관리",
        menuLvl: 1,
        url: "/rag/documents",
        tag1: "mdi-file-document-multiple"
    },
    {
        menuId: "1-2",
        upperMenuId: "1",
        upperMenuNm: "RAG Management",
        menuNm: "DB Management",
        menuDesc: "DB관리",
        menuLvl: 1,
        url: "",
        tag1: "mdi-database"
    },
    {
        menuId: "1-2-1",
        upperMenuId: "1-2",
        upperMenuNm: "DB Management",

        menuNm: "Table Management",
        menuDesc: "테이블관리",
        menuLvl: 2,
        url: "/rag/database/tables",
        tag1: "mdi-table-cog"
    },
    {
        menuId: "1-2-2",
        upperMenuId: "1-2",
        upperMenuNm: "DB Management",
        menuNm: "Meta Management",
        menuDesc: "메타관리",
        menuLvl: 2,
        url: "/rag/database/meta",
        tag1: "mdi-database-settings"
    },
    {
        menuId: "1-2-3",
        upperMenuId: "1-2",
        upperMenuNm: "DB Management",
        menuNm: "Few-shot Management",
        menuDesc: "Few-shot 관리",
        menuLvl: 2,
        url: "/rag/database/few-shot",
        tag1: "mdi-text-box-multiple-outline"
    },
    {
        menuId: "1-3",
        upperMenuId: "1",
        upperMenuNm: "RAG Management",
        menuNm: "Legislation Management",
        menuDesc: "법령관리",
        menuLvl: 1,
        url: "/rag/database/legislation",
        tag1: "mdi-gavel"
    },
    {
        menuId: "1-4",
        upperMenuId: "1",
        upperMenuNm: "RAG Management",
        menuNm: "Category Management",
        menuDesc: "분류관리",
        menuLvl: 1,
        url: "/rag/category",
        tag1: "mdi-file-tree"
    }
]);

const mainUrl = ref('/main');

const router = useRouter();


const userNm = ref("");
const authrtId = ref("");
const showRagMenu = ref(false);
const showUserMenu = ref(false);

const appBarDisplay = () => {
    emit("setDrawer");
}

const drawerUpdate = () => {
    drawer.value = !drawer.value;
};

const menuActionClick = (url, toUpperMenuName, menuName, icon) => {
    localStorage.setItem("toUrl", url);
    localStorage.setItem("toMenuName", menuName);
    localStorage.setItem("toUpperMenuName", toUpperMenuName);
    localStorage.setItem("toIcon", icon);

    if (url.indexOf('main') > 0 || url.indexOf('oper') > 0) {
        store.commit("commStore/setIsFotterShow", false);
    } else {
        store.commit("commStore/setIsFotterShow", true);
    }

    showRagMenu.value = false;
}

const mainRouter = () => {
    router.push({ name: mainUrl.value });
}

const startNewChat = () => {
    if (router.currentRoute.value.path === '/main') {
        // 이미 메인 화면에 있다면 쿼리 파라미터를 제거하고 내용을 비우는 이벤트를 발생시킵니다.
        router.push({ path: '/main', query: {} });
        window.dispatchEvent(new CustomEvent('clear-search-content'));
    } else {
        router.push('/main');
    }
}

const logout = async () => {
    try {
        await axios.post('/auth/logout');
    } catch (error) {
        console.error('Logout request failed:', error);
    } finally {
        proxy.$store.commit("commStore/clearServerCallCount");
        localStorage.removeItem("draco-user-id");
        localStorage.removeItem("draco-user-name");
        localStorage.removeItem("draco-authrt-id");
        proxy.$router.push("/login");
    }
}




const handleResize = () => {
    // let navHeight = $('#nav-wrap').height();
    // $('.hist-cover').css("height", navHeight - 340)        
}

const historySessions = ref([]);
const showSessionMenu = ref(false);
const menuSession = shallowRef(null);
const sessionMenuActivator = shallowRef(null);
let sessionMenuOpenTimer;
let sessionMenuCloseTimer;

const cancelSessionMenuTimers = () => {
    clearTimeout(sessionMenuOpenTimer);
    clearTimeout(sessionMenuCloseTimer);
    sessionMenuOpenTimer = undefined;
    sessionMenuCloseTimer = undefined;
};

const closeSessionMenu = () => {
    cancelSessionMenuTimers();
    showSessionMenu.value = false;
};

const scheduleSessionMenu = (session, event) => {
    const activator = event.currentTarget;
    if (event.type === 'focus' && !activator.matches(':focus-visible')) return;
    cancelSessionMenuTimers();
    if (showSessionMenu.value && menuSession.value?.chatSessSeq === session.chatSessSeq) return;
    showSessionMenu.value = false;
    const openTimer = setTimeout(async () => {
        if (!activator.isConnected || !drawer.value) return;
        menuSession.value = session;
        sessionMenuActivator.value = activator;
        // Vuetify must bind the new activator before calculating the menu position.
        await nextTick();
        if (sessionMenuOpenTimer !== openTimer || !activator.isConnected || !drawer.value) return;
        showSessionMenu.value = true;
    }, 300);
    sessionMenuOpenTimer = openTimer;
};

const scheduleSessionMenuClose = () => {
    cancelSessionMenuTimers();
    sessionMenuCloseTimer = setTimeout(closeSessionMenu, 250);
};

const handleSessionMenuFocusOut = (event) => {
    if (showSessionMenu.value && !event.currentTarget.contains(event.relatedTarget)) {
        scheduleSessionMenuClose();
    }
};

watch(drawer, (isOpen) => {
    if (!isOpen) closeSessionMenu();
});

const fetchSessions = async () => {
    try {
        const response = await axios.get('/chatting/sessions');
        if (response.data.status === 'success') {
            closeSessionMenu();
            historySessions.value = response.data.data.sessions;
        }
    } catch (error) {
        console.error('Failed to fetch sessions:', error);
    }
};

const loadSession = (chatSessSeq) => {
    closeSessionMenu();
    router.push({ path: '/main', query: { sess: chatSessSeq } });
};


const togglePin = async (session) => {
    closeSessionMenu();
    try {
        const newFixYn = session.fixYn === 'Y' ? 'N' : 'Y';
        const response = await axios.post(`/chatting/sessions/${session.chatSessSeq}/pin`, {
            fixYn: newFixYn
        });
        if (response.data.status === 'success') {
            fetchSessions();
        }
    } catch (error) {
        console.error('Failed to toggle pin:', error);
    }
};

const deleteSession = async (session) => {
    closeSessionMenu();
    if (!confirm('정말 삭제하시겠습니까? 해당 대화의 모든 질문과 답변이 삭제됩니다.')) return;
    try {
        const response = await axios.post(`/chatting/sessions/${session.chatSessSeq}/delete`);
        if (response.data.status === 'success') {
            fetchSessions();
            // If the deleted session is currently active, go to main
            if (router.currentRoute.value.query.sess == session.chatSessSeq) {
                router.push('/main');
            }
        }
    } catch (error) {
        console.error('Failed to delete session:', error);
    }
};

onMounted(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    window.addEventListener('refresh-chat-sessions', fetchSessions);
    userNm.value = localStorage.getItem("draco-user-name");
    authrtId.value = localStorage.getItem("draco-authrt-id");
    fetchSessions();
});

onUnmounted(() => {
    cancelSessionMenuTimers();
    window.removeEventListener('resize', handleResize);
    window.removeEventListener('refresh-chat-sessions', fetchSessions);
});

defineExpose({
    //외부 컴포넌트에서 접근 가능한 객체 정의
    drawerUpdate
})

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;800;900&display=swap');

.nav-brand-title {
    font-family: 'Outfit', sans-serif;
    font-size: 3.8rem;
    font-weight: 200;
    line-height: 1;
    letter-spacing: -0.02em;
    cursor: pointer;
    background: linear-gradient(135deg, #446ccf 0%, #2a5298 50%, #173163 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    transition: all 0.3s ease;
    filter: drop-shadow(1px 1px 0px rgba(28, 43, 102, 0.4)) drop-shadow(2px 2px 3px rgba(0, 0, 0, 0.2));
}

.nav-brand-title:hover {
    transform: translateY(-1px) scale(1.01);
    filter: drop-shadow(1px 1px 0px rgba(28, 43, 102, 0.6)) drop-shadow(2px 2px 0px rgba(28, 43, 102, 0.3)) drop-shadow(3px 3px 5px rgba(0, 0, 0, 0.3));
}

.nav-brand-subtitle-wrapper {
    margin-top: 4px;
    margin-left: 2px;
}

.nav-brand-subtitle {
    font-family: 'Outfit', sans-serif;
    font-size: 0.8rem;
    font-weight: 600;
    color: #6a7a9c;
    letter-spacing: 0.2em;
}

.nav-brand-version {
    font-weight: 800;
    color: #29429A;
    background: rgba(41, 66, 154, 0.1);
    padding: 2px 6px;
    border-radius: 4px;
    margin-left: 4px;
    font-size: 0.75rem;
}

.history-item :deep(.v-list-item-title) {
    font-size: 0.85rem !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.history-item {
    min-height: 48px !important;
    border-radius: 8px !important;
    margin: 4px 8px !important;
    transition: all 0.2s ease;
}

.history-item :deep(.v-list-item__prepend) {
    display: none !important;
}

.history-session-title {
    font-size: 0.85rem !important;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 4px;
}

.history-item :deep(.v-list-item__append) {
    margin-inline-start: 4px !important;
}

.history-item:hover {
    background-color: rgba(41, 66, 154, 0.05) !important;
}

.history-item.selected-session {
    background-color: rgba(41, 66, 154, 0.1) !important;
    border: 1px solid rgba(41, 66, 154, 0.2) !important;
}

.preview-card {
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(10px) !important;
    border: 1px solid rgba(41, 66, 154, 0.15) !important;
    border-radius: 10px !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
}

.preview-full-title {
    font-size: 0.9rem;
    font-weight: 600;
    color: #29429A;
    line-height: 1.4;
    word-break: break-all;
    flex-grow: 1;
}

.gap-2 {
    gap: 8px;
}

.rag-footer-list {
    min-width: 200px;
    border-radius: 8px !important;
    border: 1px solid rgba(0, 0, 0, 0.05) !important;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
}

.rag-footer-list :deep(.v-list-item) {
    min-height: 40px !important;
}

.rag-footer-list :deep(.v-list-item-title) {
    font-size: 0.85rem !important;
}

.rag-footer-item-l1 :deep(.v-list-item-title) {
    color: #29429A !important;
    font-weight: 600 !important;
}

.rag-footer-list :deep(.v-icon) {
    font-size: 1.1rem !important;
}

.rag-footer-header {
    opacity: 1 !important;
    background-color: transparent !important;
}

.rag-footer-submenu-group :deep(.v-list-item-title) {
    color: #29429A !important;
}

.rag-footer-submenu-group {
    border-left: 1px solid rgba(41, 66, 154, 0.2);
    margin-left: 24px;
    margin-bottom: 4px;
    padding-top: 4px;
}

.rag-footer-submenu {
    position: relative;
    padding-left: 16px !important;
}

.rag-footer-submenu::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    width: 10px;
    border-top: 1px solid rgba(41, 66, 154, 0.2);
}

.rag-footer-submenu :deep(.v-list-item-title) {
    font-size: 0.8rem !important;
    color: #757575 !important;
    font-weight: 500;
}

.rag-footer-submenu:hover {
    background-color: rgba(41, 66, 154, 0.05) !important;
}

.user-profile-clickable {
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: background-color 0.2s;
    width: fit-content;
}

.user-profile-clickable:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

.user-footer-list {
    min-width: 150px;
    border-radius: 8px !important;
    border: 1px solid rgba(0, 0, 0, 0.05) !important;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
    padding: 4px !important;
}

.logout-menu-item :deep(.v-list-item-title) {
    color: #FF5252 !important;
    font-weight: 500 !important;
}

.logout-menu-item :deep(.v-icon) {
    color: #FF5252 !important;
}
</style>
